import { render, staticRenderFns } from "./audioDetail.vue?vue&type=template&id=7232a246&scoped=true"
import script from "./audioDetail.vue?vue&type=script&lang=js"
export * from "./audioDetail.vue?vue&type=script&lang=js"
import style0 from "./audioDetail.vue?vue&type=style&index=0&id=7232a246&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7232a246",
  null
  
)

export default component.exports